import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "mall-my" }
const _hoisted_2 = { class: "mall-my__shell" }
const _hoisted_3 = {
  class: "mall-my__aside",
  "aria-label": "마이페이지 메뉴"
}
const _hoisted_4 = { class: "mall-my__brand" }
const _hoisted_5 = {
  key: 0,
  class: "mall-my__hello"
}
const _hoisted_6 = { class: "mall-my__main" }

import { useRoute } from 'vue-router'
import { useMemberAuth } from '@/composables/useMemberAuth'
import { MALL_MYPAGE_PATH, MALL_NAME } from '@/constants/mall'
import { MALL_MY_NAV } from '@/constants/mallMy'


export default /*@__PURE__*/_defineComponent({
  __name: 'MallMyLayout',
  setup(__props) {

const route = useRoute()
const { member } = useMemberAuth()

function isActive(to: string) {
  if (to === MALL_MYPAGE_PATH) return route.path === to
  return route.path === to || route.path.startsWith(`${to}/`)
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("aside", _hoisted_3, [
        _createElementVNode("header", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: _unref(MALL_MYPAGE_PATH),
            class: "mall-my__brand-link"
          }, {
            default: _withCtx(() => [
              _cache[0] || (_cache[0] = _createElementVNode("strong", null, "마이페이지", -1)),
              _createElementVNode("span", null, _toDisplayString(_unref(MALL_NAME)), 1)
            ]),
            _: 1
          }, 8, ["to"]),
          (_unref(member))
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
                _createElementVNode("b", null, _toDisplayString(_unref(member).orgName || _unref(member).bossName || _unref(member).userId), 1),
                _cache[1] || (_cache[1] = _createTextVNode(" 님 ", -1))
              ]))
            : _createCommentVNode("", true)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(MALL_MY_NAV), (group) => {
          return (_openBlock(), _createElementBlock("nav", {
            key: group.title,
            class: "mall-my__group"
          }, [
            _createElementVNode("h2", null, _toDisplayString(group.title), 1),
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: item.to
                }, [
                  _createVNode(_component_router_link, {
                    to: item.to,
                    class: _normalizeClass(["mall-my__link", { 'is-active': isActive(item.to) }])
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["to", "class"])
                ]))
              }), 128))
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("main", _hoisted_6, [
        _createVNode(_component_router_view)
      ])
    ])
  ]))
}
}

})